import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    "model-value": _ctx.modelValue,
    placeholder: "Search for a country...",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    class: "country-search bg-white q-px-sm"
  }, {
    prepend: _withCtx(() => [
      _createVNode(_component_q_icon, { name: "fa fa-search" })
    ]),
    _: 1
  }, 8, ["model-value"]))
}